import { Component, Output, EventEmitter } from '@angular/core';
import { TranslateDirective } from '../shared/translate.directive';
import { RouterModule, Router } from '@angular/router';
import { LoginService } from '../shared/services/login.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { EnglishToCyrillicDirective } from '../shared/cyrillic-input.directive';
import { SocialAuthService } from '@abacritt/angularx-social-login';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [TranslateDirective, RouterModule, CommonModule, MatIconModule, EnglishToCyrillicDirective],
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.less'
})
export class NavComponent {
  constructor(public service: LoginService, private router: Router, private socialAuthService: SocialAuthService) { }
  isLogged: boolean | undefined;
  isAdmin: boolean | undefined;
  user: any;
  @Output() closeNav = new EventEmitter<void>();

  ngOnInit(): void {

    this.user = this.service.getUser();
    this.service.contextChange.subscribe(() => {
      this.isLogged = this.service.isAuthenticated();
      this.isAdmin = this.service.isAdmin();

    });
    this.isLogged = this.service.isAuthenticated();
    this.isAdmin = this.service.isAdmin();
  }

  apply() {
    this.router.navigate(['licence-application']);
    this.closeNav.emit();
  }

  logout() {
    this.service.isLoggingOut = true;

    this.socialAuthService.signOut(true)
      .then(() => this.finalizeLogout())
      .catch(() => this.finalizeLogout());

    this.service.logout();
    this.router.navigateByUrl('/login');
    this.closeNav.emit();
  }

  onMenuItemClick() {
    this.closeNav.emit();
  }
  private finalizeLogout() {
    this.service.logout();
    this.router.navigateByUrl('/login').then(() => {
      setTimeout(() => {
        this.service.isLoggingOut = false;
      }, 500);
    });
    this.closeNav.emit();
  }
}
